/* global axios */
import ApiClient from '../ApiClient';

class WgptSocialMediaPostsAPI extends ApiClient {
  constructor() {
    super('social_media_posts', { accountScoped: true, wgpt: true });
  }

  get({ page = 1, q, status, statusNot, sortOrder, inboxId } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        q,
        status,
        status_not: statusNot,
        sort_order: sortOrder,
        inbox_id: inboxId,
      },
    });
  }

  // media entries are blob signed ids from the direct-upload flow, or raw File objects
  // when direct uploads are disabled on the installation - files go up as multipart.
  create({ media = [], ...attributes } = {}) {
    if (!media.some(item => item instanceof File)) {
      return axios.post(this.url, { ...attributes, media });
    }

    const formData = new FormData();
    Object.entries(attributes).forEach(([key, value]) =>
      formData.append(key, value)
    );
    media.forEach(item => formData.append('media[]', item));
    return axios.post(this.url, formData);
  }

  remove(id) {
    return axios.post(`${this.url}/${id}/remove`);
  }

  get directUploadUrl() {
    return `${this.url}/direct_uploads`;
  }
}

export default new WgptSocialMediaPostsAPI();
